import * as yup from 'yup';

export const loginSchema = yup.object().shape({
  username: yup.string().email('Invalid email address').required('Email is required'),
  password: yup.string().required('Password is required'),
});

export async function validateLogin(credentials) {
  try {
    await loginSchema.validate(credentials, { abortEarly: false });
    return {};
  } catch (err) {
    const errors = {};
    if (err.inner) {
      err.inner.forEach(e => {
        errors[e.path] = e.message;
      });
    }
    return errors;
  }
}

export const validateEmail = (email) => {
  const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return re.test(email);
}; 